<template lang="pug">
   .device
      .level
        WtButton.device-button(
          v-if="!isProfile && deviceText === 'Connect Device'"
          is-router-link
          color="grey"
          to="member-settings/device"
        ) {{ deviceText }}
        .level-left(v-else)
          .is-size-6 Device:&nbsp;&nbsp;
            WtRouterLink(v-if="!isProfile && deviceText !== 'Connect Device'" to="MemberDevice" :text="deviceText")
            span(v-if="isProfile") {{ deviceText }}
        .level-right
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "ConnectDevice",

  components: {
    WtButton,
    WtRouterLink,
    WtTitle
  },

  props: {
    data: {
      type: Object,
      required: true
    },

    isProfile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    deviceText() {
      let deviceApi = this._.get(this.data, "deviceApi", false);
      deviceApi = deviceApi.toString().toLowerCase();
      let deviceName = null;

      if (deviceApi) {
        if (deviceApi === "googlefit") {
          deviceName = "Google Fit";
        }
        if (deviceApi === "healthconnect") {
          deviceName = "Health Connect";
        }
        if (deviceApi === "healthkit") {
          deviceName = "Apple Health";
        }
        if (deviceApi === "garmin") {
          deviceName = "Garmin";
        }
        if (deviceApi === "samsunghealth") {
          deviceName = "Samsung Health";
        }
        if (deviceApi === "fitbit") {
          // get the device type
          deviceName = this._.get(
            this.data,
            "externalDevice.deviceName",
            "Fitbit"
          );
        }
      }
      if (deviceName) {
        return this.isProfile ? "Connected" : this._.upperFirst(deviceName);
      } else {
        return this.isProfile ? "Not Connected" : "Connect Device";
      }
    },

    memberId() {
      return this._.get(this.data, "id", false);
    }
  }
};
</script>
